import { formatIsoDateShort } from "@/lib/bookingDates";
import type { GuestTabletWelcome } from "@/types/guestTablet";

type Props = {
  welcome: GuestTabletWelcome;
  isDemo: boolean;
  /** Persönliche Datenkacheln (Anreise, Kennzeichen …) anzeigen */
  showDetails?: boolean;
};

export function TabletWelcome({ welcome, isDemo, showDetails = true }: Props) {
  return (
    <section className="guest-tablet-card p-6 md:p-8">
      {isDemo && (
        <p className="mb-3 inline-block rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-900 dark:bg-amber-900/40 dark:text-amber-100">
          Demo-Modus
        </p>
      )}
      {welcome.is_returning_guest && (
        <p className="mb-2 text-lg font-medium text-emerald-700 dark:text-emerald-300">
          Willkommen zurück
        </p>
      )}
      <h1 className="guest-tablet-hero-name text-emerald-950 dark:text-emerald-50">
        {welcome.guest_display_name}
      </h1>
      {welcome.family_hint && (
        <p className="mt-2 text-lg text-emerald-800/70 dark:text-emerald-100/70">{welcome.family_hint}</p>
      )}
      <p className="mt-4 max-w-2xl text-xl leading-relaxed text-emerald-900/80 dark:text-emerald-50/80">
        {welcome.greeting_text}
      </p>

      {showDetails ? (
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InfoTile label="Anreise" value={formatIsoDateShort(welcome.arrival_date)} />
          <InfoTile label="Abreise" value={formatIsoDateShort(welcome.departure_date)} />
          <InfoTile label="Nächte" value={String(welcome.nights)} />
          {(welcome.pitch_label || welcome.pitch_code) && (
            <InfoTile
              label="Ihr Platz"
              value={[welcome.pitch_label, welcome.pitch_code].filter(Boolean).join(" · ")}
            />
          )}
          {welcome.pitch_category && <InfoTile label="Kategorie" value={welcome.pitch_category} />}
          {welcome.license_plate && <InfoTile label="Kennzeichen" value={welcome.license_plate} />}
        </div>
      ) : null}
    </section>
  );
}

function InfoTile({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl bg-emerald-900/5 px-4 py-3 dark:bg-white/5">
      <p className="text-sm font-medium uppercase tracking-wide text-emerald-800/60 dark:text-emerald-100/50">
        {label}
      </p>
      <p className="mt-1 text-lg font-semibold">{value}</p>
    </div>
  );
}
